export const DND_ITEM_TYPES = {
  DESIGN_CARD: "DESIGN_CARD",
  PROJECT: "PROJECT",
} as const;

export interface DraggedDesignItem {
  type: typeof DND_ITEM_TYPES.DESIGN_CARD;
  designId: string;
  designName: string;
  projectId: string;
  projectName: string;
  teamId: string;
  firstImageUrl?: string;
  secondImageUrl?: string;
}

export interface DraggedProjectItem {
  type: typeof DND_ITEM_TYPES.PROJECT;
  projectId: string;
  projectName: string;
  teamId: string;
  teamName: string;
  source: "card" | "navlink";
  designs?: Array<{
    id: string;
    name: string;
    images?: Array<{
      url: string;
      side: string;
    }>;
  }>;
}
